export default "__VITE_ASSET__CZwLb9G3__"